import Layout from '@/Layout';
import Router from "next/router";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { gameActions } from "$STORE/gameSlice";

export const SmarticoDeepLink = "/rewards-centre";
function index() {
  const [isLogin, setIsLogin] = useState(false);
  const userCenter = useSelector((state) => state.userCenter);
  const dispatch = useDispatch();
  const boxexData = [
    {
      iconSrc: "/th/img/otherPageBanner/coins.svg",
      desc: "เช็กคะแนนรางวัลล่าสุดของคุณได้ทันที"
    },{
      iconSrc: "/th/img/otherPageBanner/newDesign.svg",
      desc: "รูปแบบใหม่กับประสบการณ์ที่ราบรื่นได้แล้วทุกแพลตฟอร์ม"
    },{
      iconSrc: "/th/img/otherPageBanner/newCart.svg",
      desc: "ร้านค้ารีวอร์ดที่ทันสมัยเที่ยวชมเว็บไซต์ที่น่าประทับใจ"
    },{
      iconSrc: "/th/img/otherPageBanner/newPurchase.svg",
      desc: "การแลกรับสินค้าและโบนัสได้ทันที ใช้งานง่ายไม่ยุ่งยาก"
    },{
      iconSrc: "/th/img/otherPageBanner/newGames.svg",
      desc: " กิจกรรมและมินิเกมจะสามารถแลกคะแนนได้เร็วๆ นี้!"
    },
  ]

  useEffect(() => {
    global.Pushgtagpiwikurl &&
    global.Pushgtagpiwikurl(
        "rewards-store",
        "Rewards Store"
    );}, []);

    useEffect(() => {
        console.log("userCenter?.memberInfo?.memberCode", userCenter?.memberInfo)
        if(userCenter?.memberInfo?.memberCode && userCenter?.memberInfo?.memberCode !== "") {
            setIsLogin(true);
        }
    }, [userCenter?.memberInfo?.memberCode]); 

  const Bonx = ({iconSrc, desc}) => {
    return (
      <div style={{display: "flex", flexDirection:"column", alignItems:"center", marginBottom: "20px"}}>
        <img src={iconSrc} alt="icon" style={{width: "50px", height: "50px"}}/>
        <p style={{marginLeft: "10px", marginTop:"8px"}}>{desc}</p>
      </div>
    )
  }

  return (
      <Layout status={1}>
          <div
              style={{
                  width: "100%",
                  minHeight: "1117px",
              }}
          >
              <div>
                  <img
                      src="/th/img/otherPageBanner/TH_rewardbanner_desktop.jpg"
                      alt="smarticoEntry"
                      style={{ width: "100%" }}
                  />
              </div>
              <div
                  style={{
                      width: "100%",
                      textAlign: "center",
                  }}
              >
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "28px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                          รีวอร์ดโฉมใหม่พร้อมให้บริการแล้วที่ "มุมรางวัล"
                      </p>
                      <p
                          style={{
                              fontWeight: 400,
                              fontSize: "20px",
                              color: "#666666",
                              marginTop: "20px",
                          }}
                      >
                          เพลิดเพลินไปกับประสบการณ์การช็อปปิ้งที่ราบรื่นและคุ้มค่ามากยิ่งขึ้นที่ FUN88!
                      </p>
                  </div>
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "24px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                          อัปเดตใหม่ที่คุณต้องรู้!
                      </p>
                      <div
                          style={{
                              width: "100%",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              marginTop: "28px",
                          }}
                      >
                          {boxexData.map((item, index) => {
                              return (
                                  <div
                                      key={index}
                                      style={{
                                          width: "208px",
                                          padding: "10px",
                                      }}
                                  >
                                      <Bonx
                                          iconSrc={item.iconSrc}
                                          desc={item.desc}
                                      />
                                  </div>
                              );
                          })}
                      </div>
                  </div>
                  <div
                      style={{
                          width: "100%",
                          marginTop: "60px",
                      }}
                  >
                      <h3>สำรวจร้านค้ารูปแบบใหม่ได้แล้ววันนี้และสิทธิประโยชน์จากรางวัลมากมายรอคุณอยู่!</h3>
                  </div>
                  <div>
                      <img
                          onClick={() =>{
                            if(!isLogin) {
                                dispatch(gameActions.setCacheGame({ type: "smarticoViaDeepLink" }));
                              global.goUserSign("1");
                              return
                            }
                            Pushgtagdata(
                                "RewardsStore",
                                "GO to Reward Centre",
                                "RewardsStore_C_Exchange",
                            );
                            Router.push(SmarticoDeepLink);
                          }
                          }
                          src="/th/img/otherPageBanner/Button.svg"
                          alt="smarticoEntry"
                          style={{
                              width: "278px",
                              height: "56%",
                              cursor: "pointer",
                              marginTop: "52px",
                          }}
                      />
                  </div>
                  <div
                  style={{
                    marginTop: "52px",
                  }}
                  >
                      ต้องการข้อมูลเพิ่มเติม?{" "}
                      <span
                          style={{
                              color: "#00A6FF",
                              cursor: "pointer",
                              textDecoration: "underline",
                          }}
                          onClick={() =>{
                            Pushgtagdata(
                                "RewardsStore",
                                "GO to Help Center",
                                "RewardsStore_C_HelpCenter",
                            );
                            window.open('/th/customer-service')
                          }
                          }
                      >
                          ศูนย์ช่วยเหลือ
                      </span>
                  </div>
              </div>
          </div>
      </Layout>
  );
}

export default index